import styles from "./index.css";
import PropTypes from "prop-types";

const ViewMore = ({ expanded, formatTranslation, onButtonClick }) => (
  <button className={styles.viewMore} onClick={onButtonClick}>
    {expanded
      ? formatTranslation("plp_web_view_less_button_label")
      : formatTranslation("plp_web_view_more_button_label")}
  </button>
);

ViewMore.propTypes = {
  expanded: PropTypes.bool.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  onButtonClick: PropTypes.func.isRequired
};

export default ViewMore;
